import React, { useContext } from 'react';
import { COUNTRIES_LIST } from 'lib/countries';

import {
    FormGroup,
    FormControl,
    Dropdown,
    Alert,
    ButtonSelect,
    ShopifyResourcePicker,
    Button
} from 'components';
import { CAMPAIGN_TARGETS } from 'lib/globals';
import ShopContext from 'context/ShopContext';
import CampaignTarget from './CampaignTarget';
const GeoTargeting = ({ context }) => {
    const { state: campaign, validationErrors, validate } = context;
    const shopContext = useContext(ShopContext);

    return (
        <FormGroup
            label="Targeting"
            info="Target specific products you would like to include/exclude for this campaign. (If no countries have been selected campaign will show to all users."
        >
            {campaign.settings.type === 'add_to_unlock' && <CampaignTarget context={context} />}
            <FormControl
                label="Target specific countries"
                withSwitch={[context, 'target.countries.include_active']}
                info={
                    campaign.target.countries.include_active
                        ? 'Choose countries you would like to show your campaign too.'
                        : ''
                }
            >
                {campaign.target.countries.include_active &&
                    <Dropdown
                        disabled={!campaign.target.countries.include_active}
                        options={COUNTRIES_LIST}
                        isMulti={true}
                        first
                        BindToContext={[context, 'target.countries.include']}
                    />}
            </FormControl>
            <FormControl
                label="Exclude countries"
                withSwitch={[context, 'target.countries.exclude_active']}
                info={
                    campaign.target.countries.exclude_active
                        ? 'Hide this campaign from these countries.'
                        : ''
                }
            >
                {campaign.target.countries.exclude_active &&
                    <Dropdown
                        disabled={!campaign.target.countries.exclude_active}
                        options={COUNTRIES_LIST}
                        isMulti={true}
                        first
                        BindToContext={[context, 'target.countries.exclude']}
                    />}
            </FormControl>
        </FormGroup>
    );
};

export default GeoTargeting;
